// import type { LngLat, RouteOptions, TruckParameters } from '@yandex/ymaps3-types';
import { makeRequest } from '../../../../lib/api';
import {
  EvacuationPriceRequest,
  TowTruckDriverRequest,
  CreateRefusalRequest,
  OrdersByValuesRequestInterface,
  EvacuatorOrderReqestInterface,
  // RouteRequestInterface,
} from '../../api/evacuationApi';

/* ymaps3.ready.then(() => {
  ymaps3.import.registerCdn('https://cdn.jsdelivr.net/npm/{package}', '@yandex/ymaps3-default-ui-theme@0.0');

  // Copy your api key for routes from the developer's dashboard and paste it here
  ymaps3.getDefaultConfig().setApikeys({ router: process.env.YANDEX_ROUTE_API_KEY });
}); */

const EVACUATION_PATH = '/v1/users/evacuation_price';
const TOW_TRUCK_DRIVERS_PATH = '/v1/users/tow_truck/drivers';
const BASE_TRUCK_POINTS_PATH = '/v1/partner_office/tow_truck_bases';
const PARTNER_OFFICE_REFUSE = '/v1/orders/partner_office_refuse';
const EVACUATOR_ORDERS_PATH = '/v1/orders/evacuation';
const AVARCOM_ORDERS_PATH = '/v1/orders/avarcom_and_realty';
const TBANK_AVARCOM_ORDERS_PATH = '/v1/orders/t_avarcom';
const ORDER_PATH = '/v1/orders';

/*async function fetchRoute(
  startCoordinates: LngLat,
  endCoordinates: LngLat,
  type: RouteOptions['type'] = 'driving'
) {
  let truck: TruckParameters;
  if (type === 'truck') {
    // set truck with trailer by default
    truck = {
      weight: 40,
      maxWeight: 40,
      axleWeight: 10,
      payload: 20,
      height: 4,
      width: 2.5,
      length: 16,
      ecoClass: 4,
      hasTrailer: true,
    };
  }

  return;
  // Request a route from the Router API with the specified parameters.
  const routes = await ymaps3.route({
    points: [startCoordinates, endCoordinates], // Start and end points of the route LngLat[]
    type, // Type of the route
    bounds: true, // Flag indicating whether to include route boundaries in the response
    truck,
  });

  // Check if a route was found
  if (!routes[0]) return;

  // Convert the received route to a RouteFeature object.
  const route = routes[0].toRoute();

  // Check if a route has coordinates
  if (route.geometry.coordinates.length == 0) return;

  return route;
} */

const evacuationController = {
  getEvacuationPriceResponse: (request: EvacuationPriceRequest): Promise<any> => {
    return makeRequest('post', `${ EVACUATION_PATH }`, request);
  },

  getTowTruckDrivers: (request: TowTruckDriverRequest): Promise<any> => {
    return makeRequest('get', `${ TOW_TRUCK_DRIVERS_PATH }?refValueId=${ request.towTruckTypeRefValueId }`);
  },

  getBaseTruckPoints: (orderId: string): Promise<any> => {
    return makeRequest('get', `${ BASE_TRUCK_POINTS_PATH }?orderId=${ orderId }`);
  },

  createRefusal: (request: CreateRefusalRequest): Promise<any> => {
    return makeRequest('post', `${ PARTNER_OFFICE_REFUSE }`, request);
  },

  getEvacuatorOrders: (request: EvacuatorOrderReqestInterface): Promise<any> => {
    return makeRequest('post', `${ EVACUATOR_ORDERS_PATH }`, request);
  },

  getAvarcomOrders: (): Promise<any> => {
    return makeRequest('get', `${ AVARCOM_ORDERS_PATH }`);
  },

  getTBankAvarcomOrders: (): Promise<any> => {
    return makeRequest('get', `${ TBANK_AVARCOM_ORDERS_PATH }`);
  },

  getOrderByValues: (request: OrdersByValuesRequestInterface): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH }/find_list`,request );
  },

  getOrderPhotos: (orderId, showDeleted = false, sourceRefValues = null) : Promise<any> => {
    let showDeletedString = showDeleted ? '?show-deleted=true' : '?show-deleted=false';
    if (sourceRefValues && (sourceRefValues.length > 0)) {
      sourceRefValues.forEach((v) => {
        showDeletedString = `${ showDeletedString }&source=${ String(v) }`;
      });
    }
    return makeRequest('get', `${ ORDER_PATH }/${ orderId }/photos${ showDeletedString }`);
  },

  getTEvacuatorOrders: (): Promise<any> => {
    return makeRequest('get', `${ EVACUATOR_ORDERS_PATH }/by_user`);
  },

  getTEvacuatorOrdersReport: (): Promise<any> => {
    return makeRequest('get', `${ EVACUATOR_ORDERS_PATH }/by_user/report`);
  },

  // getRoute: (request:RouteRequestInterface) => {
  // return fetchRoute(request.startCoordinates, request.endCoordinates);
  // return makeYandexRequest('get', `${ YANDEX_PATH }?waypoints=${ request.startLat },${ request.startLng }|${ request.endLat },${ request.endLng }&apikey=84352203-c9a5-4b0d-a765-0e5ec9e87763&mode=driving`, request);
  // return makeYandexRequest('get', `${ YANDEX_PATH }?waypoints=55.59593923192594%2C37.716406427865685%7C55.80647951514909%2C37.399010743931825&apikey=84352203-c9a5-4b0d-a765-0e5ec9e87763&mode=driving`, request);
  //},

  // https://api.routing.yandex.net/v2/route?waypoints=55.59593923192594%2C37.716406427865685%7C55.80647951514909%2C37.399010743931825&apikey=79140fc9-4dd1-44f8-bc71-a2d91e56d631&mode=driving

};

export { evacuationController };
